import { FunctionComponent, SVGProps } from 'react';
import { SelectProps } from 'antd';
import { StyledXIcon } from 'components/atoms/StyledIcons';
import { AppText } from 'components/atoms/CommonAppComponents/AppText/AppText';
import {
    GlobalStyle,
    InnerContainer,
    OuterContainer,
    StyledSelect,
} from './AppCustomSelect.styled';
import { SelectTagRender } from '../components/SelectTagRender/SelectTagRender';
import { SelectSuffixIcon } from '../components/SelectSuffixIcon/SelectSuffixIcon';

export type AppCustomSelectProps = SelectProps & {
    label?: string;
    isFitContentWidth?: boolean;
    Icon?: FunctionComponent<SVGProps<SVGSVGElement>>;
    accessibilityLabel?: string;
};

export const AppCustomSelect = ({
    label,
    Icon,
    loading,
    isFitContentWidth,
    optionFilterProp = 'label',
    onClick,
    suffixIcon,
    accessibilityLabel,
    ...props
}: AppCustomSelectProps) => {
    return (
        <OuterContainer isFitContentWidth={isFitContentWidth}>
            {label ? (
                <AppText margin={0} textType="BodyMSSemiBold">
                    {label}
                </AppText>
            ) : null}
            <InnerContainer>
                <GlobalStyle />
                {Icon && <Icon width={20} height={20} />}
                <StyledSelect
                    {...props}
                    open={false}
                    showSearch={false}
                    tagRender={SelectTagRender}
                    maxTagCount="responsive"
                    optionFilterProp={optionFilterProp}
                    suffixIcon={<SelectSuffixIcon loading={loading} suffixIcon={suffixIcon} />}
                    allowClear={{ clearIcon: <StyledXIcon /> }}
                    loading={loading}
                    isFitContentWidth={isFitContentWidth}
                    aria-label={accessibilityLabel}
                    onClick={(e) => {
                        e.preventDefault();

                        if (!props.disabled) {
                            onClick?.(e);
                        }
                    }}
                />
            </InnerContainer>
        </OuterContainer>
    );
};
